import { CheckCircleIcon, XCircleIcon, PlayCircleIcon, ClipboardDocumentListIcon } from "@heroicons/react/24/solid";
import { ChecklistItem as ChecklistItemType } from "../../data/productionLineMock";

type Props = {
  item: ChecklistItemType;
};

export default function ChecklistItem({ item }: Props) {
  const baseLabel = item.label.split(" - ")[0];

  const icon =
    item.status === "damaged" ? (
      <XCircleIcon className="h-4 w-4 text-red-500 mt-0 shrink-0" />
    ) : item.status === "todo" ? (
      <ClipboardDocumentListIcon className="h-4 w-4 text-gray-400 mt-0 shrink-0" />
    ) : item.status === "current" ? (
      <PlayCircleIcon className="h-4 w-4 text-blue-500 mt-0 shrink-0" />
    ) : (
      <CheckCircleIcon className="h-4 w-4 text-green-500 mt-0 shrink-0" />
    );

  return (
    <li className="flex items-start gap-1.5">
      {icon}
      <span className="text-xs text-gray-800 dark:text-gray-200 leading-tight">
        {baseLabel}
      </span>
    </li>
  );
}


